import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getRecentShows, recentShowsDto } from "../../api";

export enum Status {
    INACTIVE = "INACTIVE",
    LOADING = "LOADING",
    SUCCESSFUL = "SUCCESSFUL",
    ERROR = "ERROR",
}

export interface RecentShowsState {
    details: recentShowsDto;
    status?: Status;
}

const initialState: RecentShowsState = {
    details: {data: null},
    status: Status.INACTIVE,
}

export const recentShowsSlice = createSlice({
    name: 'recentShows',
    initialState,
    reducers: {
        setRecentShowsState: (state: RecentShowsState, action: PayloadAction<RecentShowsState>) => {
            state.details = action.payload.details;
        },
        resetRecentShowsState: (state: RecentShowsState) => {
            state.details = initialState.details;
            state.status = initialState.status;
        },
        recentShowsStateStart: (state: RecentShowsState) => {
            state.status = Status.LOADING;
        },
        recentShowsStateEnd: (state: RecentShowsState, action: PayloadAction<Status>) => {
            state.status = action.payload;
        }
    }
});

export const {
    setRecentShowsState,
    resetRecentShowsState,
    recentShowsStateStart,
    recentShowsStateEnd,
} = recentShowsSlice.actions;

export const loadRecentShows = () => async (dispatch, getState) => {
    dispatch(recentShowsStateStart());
    try {
        const response = await getRecentShows();
        dispatch(setRecentShowsState({details: response}));
        dispatch(recentShowsStateEnd(Status.SUCCESSFUL));
    }catch(e){
        dispatch(setRecentShowsState({details: null}));
        dispatch(recentShowsStateEnd(Status.ERROR));
    }
}